<template>
  <div>
    <div style="margin-left: 250px; overflow-y: auto; height: 85vh;">
      
      <el-card style="margin-bottom: 30px;">
       <div style="display: flex;justify-content: space-between;">
        <div style="width: 50%;  text-align: end;"><span style="font-size: 19px;font-weight: 900;">薪酬类型</span></div>
        <div><i style="font-size: 25px;color: #409EFF;"  class="el-icon-circle-close" @click="handleReturn"></i> </div>
       </div>
      </el-card>

        
      <el-card>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item title="底薪" name="1">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[0] }">底薪</div> 
                <div>{{ rank }}</div>
              </div>
            </template>
            <div style="border: 1px solid #EBEEF5; display: flex; border-radius: 3px;"> 
              <div style="width: 10%;padding: 15px 8px;">职级:</div>
              <div style="width: 40%;padding: 15px 8px; border-right: 1px solid #EBEEF5; border-left: 1px solid #EBEEF5;">{{ dataObj.rankName }}</div>
              <div style="width: 40%;padding: 15px 8px">
                <el-input   v-if="rankShow"  style="width: 100%;" size="small" v-model="rank"></el-input>
                <span v-if="!rankShow">{{ rank }}</span>
              </div>
              <div style="width: 10%;padding: 15px 8px;border-left: 1px solid #EBEEF5;">
               <!--  <span style="color: #409EFF;" @click="handleView('查看','底薪')">查看</span>-->
                <span style="color: #409EFF;" @click="handleView('编辑','底薪')">编辑</span>
                <span style="color: #409EFF;"  v-if="rankShow"  @click="handleView('保存','底薪')">保存</span>
              </div> 
            </div>
          </el-collapse-item>

          <el-collapse-item title="管理绩效" name="2">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[1] }">管理绩效</div> 
                <div>{{ managementRankFees }}</div>
              </div>
            </template>
            <div style="border: 1px solid #EBEEF5; display: flex; border-radius: 3px;"> 
              <div style="width: 10%;padding: 15px 8px;">管理职级:</div>
              <div style="width: 40%;padding: 15px 8px; border-right: 1px solid #EBEEF5; border-left: 1px solid #EBEEF5;">{{ dataObj.rankManageName}}</div>
              <div style="width: 40%;padding: 15px 8px">
                <el-input   v-if="managementRankFeesShow"  style="width: 100%;" size="small" v-model="managementRankFees"></el-input>
                <span v-if="!managementRankFeesShow">{{ managementRankFees }}</span>
              </div>
              <div style="width: 10%;padding: 15px 8px;border-left: 1px solid #EBEEF5;">
                <!-- <span style="color: #409EFF;" @click="handleView('查看','管理职级')">查看</span> -->
                <span style="color: #409EFF;" @click="handleView('编辑','管理绩效')">编辑</span>
                <span style="color: #409EFF;"  v-if="managementRankFeesShow"  @click="handleView('保存','管理绩效')">保存</span>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item title="课时费" name="3">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[2] }">课时费</div> 
                <div>{{ monthClassFee }}</div>
              </div>
            </template>
            <el-table  :data="tableData" border  style="width: 100%"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
              <el-table-column fixed  prop="date" label="学段"></el-table-column>
              <el-table-column fixed  prop="name" label="上门"></el-table-column>
              <el-table-column fixed  prop="address" label="网课"></el-table-column>
              <el-table-column fixed  prop="time" label="门店"></el-table-column>
              <el-table-column fixed  prop="price" label="课时费"></el-table-column>
              <el-table-column fixed  label="操作" >
                <template slot-scope="scope">
                  <span style="color: #409EFF;" @click="handleView('查看','课时费',scope.row)">查看</span>
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">查看</el-button> -->
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">编辑</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="补助" name="4">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[3] }">补助</div> 
                <div>{{ subsidy }}</div>
              </div>
            </template>
            <el-table  :data="tableData1" border  style="width: 100%"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
              <el-table-column fixed  prop="date" label="类型"></el-table-column>
              <!-- <el-table-column fixed  prop="name" label="全路补(大于1小时)"></el-table-column>
              <el-table-column fixed  prop="address" label="部分路补(小于1小时)"></el-table-column> -->
              <!-- <el-table-column fixed  prop="name" label="数量">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" style="width: 100%;" size="small" v-model="scope.row.name"></el-input>
                    <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
                  </template>
              </el-table-column> -->
              <el-table-column fixed  prop="name" label="数量"></el-table-column>
              
              <el-table-column fixed  prop="address" label="费用">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" style="width: 100%;" size="small" v-model="scope.row.address"></el-input>
                    <span v-if="!scope.row.isEdit">{{ scope.row.address }}</span>
                  </template>
              </el-table-column>
              <el-table-column fixed  label="操作" >
                <template slot-scope="scope">
                  <span style="color: #409EFF;" @click="handleView('查看','补助',scope.row)">查看</span>
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">查看</el-button> -->
                  <el-button @click="handleView('编辑','补助',scope.row)" type="text" size="small">编辑</el-button>
                   <span style="color: #409EFF;" v-if="scope.row.isEdit"  @click="handleView('保存', '补助', scope.row)">保存</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="奖励" name="5">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[4] }">奖励</div> 
                <div>{{ award }}</div>
              </div>
            </template>
            <el-table  :data="tableData2" border  style="width: 100%"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
              <el-table-column fixed  prop="date" label="类型"></el-table-column>
              <el-table-column fixed  prop="name" label="数量"></el-table-column>
              <el-table-column fixed  prop="address" label="费用"></el-table-column>
              <el-table-column fixed  label="操作" >
                <template slot-scope="scope">
                  <span style="color: #409EFF;" @click="handleView('查看','奖励',scope.row)">查看</span>
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">查看</el-button> -->
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">编辑</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="义务课时" name="6">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[5] }">义务课时</div> 
                <div>{{  CompulsoryLessonFee }}</div>
              </div>
            </template>
            <div style="border: 1px solid #EBEEF5; display: flex; border-radius: 3px;"> 
              <div style="width: 10%;padding: 15px 8px;">义务课时费:</div>
              <div style="width: 90%;padding: 15px 8px; border-right: 1px solid #EBEEF5; border-left: 1px solid #EBEEF5;">{{  CompulsoryLessonFee }}</div>
              <!-- <div style="width: 10%;padding: 15px 8px;border-left: 1px solid #EBEEF5;">
                <span style="color: #409EFF;" @click="handleView('查看','义务课时')">查看</span>
                <span style="color: #409EFF;" @click="handleView('查看',)">查看</span>
                <span style="color: #409EFF;" @click="handleView('编辑',)">编辑</span>
              </div> -->
            </div>
          </el-collapse-item>

          <el-collapse-item title="扣款" name="7">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[6] }">扣款</div> 
                <div>{{ withhold }}</div>
              </div>
            </template>
            <el-table  :data="tableData3" border  style="width: 100%"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
              <el-table-column fixed  prop="date" label="类型"></el-table-column>
              <el-table-column fixed  prop="name" label="数量">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" style="width: 100%;" size="small" v-model="scope.row.name"></el-input>
                    <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
                  </template>
              </el-table-column>
              <el-table-column fixed  prop="address" label="费用">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" style="width: 100%;" size="small" v-model="scope.row.address"></el-input>
                    <span v-if="!scope.row.isEdit">{{ scope.row.address }}</span>
                  </template>
              </el-table-column>
              <el-table-column fixed  label="操作" >
                <template slot-scope="scope">
                  <!-- <el-button @click="handleClickTable(scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="handleClickTable(scope.row)" type="text" size="small">编辑</el-button> -->
                  <!-- <span style="color: #409EFF;" @click="handleView('查看','扣款')">查看</span> -->
                  <span style="color: #409EFF;" @click="handleView('编辑','扣款', scope.row)">编辑</span>
                  <span style="color: #409EFF;" v-if="scope.row.isEdit"  @click="handleView('保存', '扣款', scope.row)">保存</span>
                  <!-- <span style="color: #409EFF;" v-if="scope.row.isEdit" @click="handleView('取消','扣款', scope.row)">取消</span> -->
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

          <el-collapse-item title="社保" name="8">
            <template #title>
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <div :style="{ color: colorList[7] }">社保</div> 
              </div>
            </template>
            <el-table  :data="tableData4" border height="100"  style="width: 100%"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
              <el-table-column fixed  prop="address" label="费用">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.isEdit" style="width: 100%;" size="small" v-model="scope.row.address"></el-input>
                    <span v-if="!scope.row.isEdit">{{ scope.row.address }}</span>
                  </template>
              </el-table-column>
              <el-table-column fixed  label="操作" >
                <template slot-scope="scope">
                  <span style="color: #409EFF;" @click="handleView('编辑','社保', scope.row)">编辑</span>
                  <span style="color: #409EFF;" v-if="scope.row.isEdit"  @click="handleView('保存', '社保', scope.row)">保存</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

        </el-collapse>
      </el-card>


      <el-card style="margin-top: 20px;">

        <div style="width: 100%;display: flex;">
          <div style="width: 50%;">
            <div style="text-align: start; margin-bottom: 7px;">复核内容：</div>
            <div class="box">
               <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                <div v-if="itme.creatTime">提交时间：{{ itme.creatTime }}</div>
                <div v-if="itme.auditContent">审核人：{{ itme.auditContent }}</div>
                <div v-if="itme.PCTime">提交时间：{{ itme.PCTime }}</div>
               </div>
            </div>
          </div>
          <div style="width: 50%;margin-left: 10px;">
            <div style="text-align: start; margin-bottom: 7px;">复核建议：</div>
            <div>
               <el-input resize="none"  type="textarea"  :autosize="{  minRows: 9, maxRows: 9 }"  v-model="textareass"> </el-input>
            </div>
            
          </div>
        </div>

        <div style="width: 100%;text-align: end; margin-top: 20px;">
          <el-button type="primary" class="btns" style="margin-left: 20px;" :disabled="notarizeType != 3"  @click="handleClick">发送</el-button>
        </div> 
       
      </el-card>

      
    </div>




    <el-dialog  modal-append-to-body append-to-body :close-on-click-modal="false" :visible.sync="dialogVisiblehandleClosedataList" width="60%" :before-close="handleClosedataList">

      <!-- <div style="display: flex;">
        <div style="padding-top: 10px;width: 100px;">课次:</div>
        <el-select   class="select"  v-model="sourceswayType"   placeholder="请选择来源"  style="width: 100%"   filterable  clearable  >
           <el-option  v-for="source in sources"  :key="source.id"  :value="source.id"  :label="source.name"  >  </el-option>
        </el-select>
        <div style="width: 100%;text-align: end; margin-top: 20px;">
          <el-button type="primary" class="btns" style="margin-left: 20px;" @click="handleClick11111111">搜索</el-button>
        </div> 
      </div> -->



      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }" :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
        <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseStartTime" label="开始时间"></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间"></el-table-column>
        <el-table-column prop="categoryName" label="课程"></el-table-column>
        <el-table-column prop="educationType" label="上课方式">
          <template slot-scope="scope">
              <span v-if="scope.row.educationType === 2 ">上门</span>
              <span v-if="scope.row.educationType === 1 ">网课</span>
              <span v-if="scope.row.educationType === 3 ">门店</span>
          </template>
        </el-table-column>
        <el-table-column prop="studentName" label="学员"></el-table-column>
        <el-table-column prop="isSales" label="课消状态">
          <template slot-scope="scope">
              <span v-if="scope.row.isSales == 0 ">未课消</span>
              <span v-else-if="scope.row.isSales == 1 ">已课消</span>
              <span v-else>全部</span>
          </template>
        </el-table-column>
        <el-table-column prop="salaryNum" label="课消次数"></el-table-column>

      </el-table>
      
      <div style="text-align: end; margin-top: 20px;">
        <el-button class="btns" @click="handleClosedataList">取消</el-button>
      </div>

    </el-dialog>


    <el-dialog  modal-append-to-body append-to-body :close-on-click-modal="false" :visible.sync="dialogVisiblehandleClosedataList1" width="80%" :before-close="handleClosedataList1">


      <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"  :cell-style="{ 'text-align': 'center' }" :data="dataList1" border height="700">
        <el-table-column prop="regionNames" label="所在地域" show-overflow-tooltip></el-table-column>
        <el-table-column prop="expandTeacherName" label="扩科教师" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="课程" show-overflow-tooltip></el-table-column>
        <el-table-column prop="teacherName" label="上课教师" show-overflow-tooltip></el-table-column>
        <el-table-column prop="studentName" label="学生" show-overflow-tooltip></el-table-column>
        <el-table-column prop="classNum" label="已上课节数" show-overflow-tooltip  width="100"></el-table-column>
        <el-table-column prop="isReach" label="达标情况" show-overflow-tooltip>
          <template v-slot="scope">
            <div v-if="scope.row.isReach === 2">已达标</div>
            <div v-else>未达标</div>
          </template>
        </el-table-column>
        <el-table-column prop="awardType" label="奖励情况" show-overflow-tooltip>
          <template v-slot="scope">
            <div  v-if="scope.row.awardType === 1">否</div>
            <div  v-if="scope.row.awardType === 2">是</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="170"></el-table-column>
        <el-table-column prop="awardTime" label="奖励日期" show-overflow-tooltip width="110"></el-table-column>
        
      </el-table>

      <div style="text-align: end; margin-top: 20px;">
        <el-button class="btns" @click="handleClosedataList1">取消</el-button>
      </div>

    </el-dialog>



    <el-dialog  modal-append-to-body append-to-body :close-on-click-modal="false" :visible.sync="dialogVisiblehandleClosedataList2" width="90%" :before-close="handleClosedataList2">


      <el-table   :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList2" border height="700">
          <el-table-column prop="name" show-overflow-tooltip label="姓名"></el-table-column>
          <el-table-column prop="sex" show-overflow-tooltip label="性别">
              <template slot-scope="scope">
                  <span  v-if=" scope.row.sex === 1 ">男</span>
                  <span  v-if=" scope.row.sex === 2 ">女</span>
              </template>
          </el-table-column>
          <el-table-column prop="regionName" show-overflow-tooltip label="所属城市"></el-table-column>
          <el-table-column prop="telPhone" show-overflow-tooltip label="手机"></el-table-column>
          <el-table-column prop="email" show-overflow-tooltip label="邮箱"></el-table-column>
          <el-table-column prop="age" show-overflow-tooltip label="年龄"></el-table-column>
          <el-table-column prop="deptName" show-overflow-tooltip label="岗位"></el-table-column>
          <el-table-column prop="teach" show-overflow-tooltip label="科目"></el-table-column>
          <el-table-column prop="notePush" show-overflow-tooltip label="是否内推">
              <template slot-scope="scope">
                  <span  v-if=" scope.row.notePush === 1 ">是</span>
                  <span  v-if=" scope.row.notePush === 2 ">否</span>
              </template>
          </el-table-column>
          <el-table-column prop="pushPeople" show-overflow-tooltip label="内推人"></el-table-column>
          <el-table-column prop="createName" show-overflow-tooltip label="提交人"></el-table-column>
          <el-table-column prop="createTime" show-overflow-tooltip label="提交时间"></el-table-column>
          <el-table-column prop="createTime" show-overflow-tooltip label="入职时间"></el-table-column>
          <el-table-column prop="resumeStatus" show-overflow-tooltip label="简历状态">
              <template slot-scope="scope">
                  <span  v-if=" scope.row.resumeStatus === 0 ">待面试</span>
                  <span  v-if=" scope.row.resumeStatus === 1 ">面试中</span>
                  <span  v-if=" scope.row.resumeStatus === 2 ">未通过</span>
                  <span  v-if=" scope.row.resumeStatus === 3 ">待发offer</span>
                  <span  v-if=" scope.row.resumeStatus === 4 ">待入职</span>
                  <span  v-if=" scope.row.resumeStatus === 5 ">拒绝offer</span>
                  <span  v-if=" scope.row.resumeStatus === 6 ">已入职</span>
                  <span  v-if=" scope.row.resumeStatus === 7 ">取消面试</span>
              </template>
          </el-table-column>
                
            
       </el-table>

      <div style="text-align: end; margin-top: 20px;">
        <el-button class="btns" @click="handleClosedataList2">取消</el-button>
      </div>

    </el-dialog>


  </div>
</template>


<script>
import apiBaseUrl from "../../../config/api";
import axios from "axios";


export default {
  components: {
   
  },
  props: {
    DetailsRow: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      activeName: '',
    

      sourceswayType: '',

      doubtContent: [],
      textareass: '',

      rowObj: {},

      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],

      colorList: [],

      dialogVisiblehandleClosedataList: false,
      dataList: [],

      dialogVisiblehandleClosedataList1: false,
      dataList1: [],

      dialogVisiblehandleClosedataList2: false,
      dataList2: [],

      isTyle: false,

      managementRankFees: '',
      managementRankFeesShow: false,

      rankShow: false,
      rank: '',


      dataObj: {},


      CompulsoryLessonFee: '',

      monthClassFee: '',
      subsidy: '',
      award: '',
      withhold: '',

      notarizeType: '',


      sources: [
        { id: 1, name: '全课次' },
        { id: 2, name: '半课次' },
      ],

    }
  },
  created () {

  },


  mounted () {
  
    this.getList();

  },

  methods: {

    handleReturn(){
       this.$emit('handleEmitButs', false, 'bomm')
    },

    handleClick11111111(tab, event) {
       let url = '/salary/findTeacherWay'
       this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, wayType: this.sourceswayType}, 1)
    },

    getList() {
      axios.get(`${apiBaseUrl}/salary/detailInfo/${this.DetailsRow.id}`, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.data.code == 200){
            let data = response.data.data
            this.dataObj = data
            this.rank = data.basicSalary
            this.managementRankFees = data.managePerformance
            this.CompulsoryLessonFee = data.dutyClassFee

            this.monthClassFee = data.monthClassFee
            this.subsidy = data.subsidy
            this.award = data.award
            this.withhold = data.withhold

            this.notarizeType = data.notarizeType
            


            this.tableData = [
              { date: '小学', name: data.littleVisit , address: data.littleNetwork, time: data.littleShop, price: data.littleCost, },
              { date: '初中', name: data.centreVisit , address: data.centreNetwork, time: data.centreShop, price: data.centreCost, },
              { date: '高中', name: data.tallVisit , address: data.tallNetwork, time: data.tallShop, price: data.tallCost, },
            ]

            this.tableData1 = [
              // { date: '上门路补(全)', name: data.wayGreater, address: data.wayGreaterMoney, time: data.wayMoney, isEdit: false },
              // { date: '上门路补(半)', name: data.wayLess, address: data.wayLessMoney, time: data.wayMoney, isEdit: false },
              { date: '上门路补(课时)', name: data.wayNum, address: data.wayMoney, time: data.wayMoney, isEdit: false },
              { date: '单日五节(天)', name: data.oneClassNum, address: data.oneClassMoney, time: data.oneClassMoney, isEdit: false },
              { date: '晚10路补(节)', name: data.nightEightNum, address: data.nightEightMoney, time: data.nightEightMoney, isEdit: false },
              { date: '远程路补(节)', name: data.longWayNum, address: data.longWayMoney, time: data.longWayMoney, isEdit: false },
              { date: '社保补助', name: 0, address: data.socialSecurityFee, time: data.socialSecurityFee, isEdit: false },
            ]

            this.tableData2 = [
              { date: '扩科奖励(科)', name: data.expandNum, address: data.expandAward, },
              { date: '内推奖励(人)', name: data.alreadyRecommenderNum, address: data.isAlreadyRecommenderFee, },
            ]

            this.tableData3 = [
              { date: '上班迟到扣款(次)', name: data.dutyLateNum, address: data.dutyLateWithhold, isEdit: false },
              { date: '上课迟到扣款(次)', name: data.classLateNum, address: data.classLateWithhold, isEdit: false },
              { date: '教学事故扣款(次)', name: data.teachingAccidentNum, address: data.teachingAccidentWithhold, isEdit: false },
              { date: '周末/节假日请假扣款(次)', name: data.leaveNum, address: data.leaveWithhold, isEdit: false },
              { date: '事假扣款', name: data.matterLeaveNum, address: data.matterLeaveWithhold, isEdit: false },
            ]

             this.tableData4 = [
              { date: '社保金额', name: 0, address: data.socialSecurityWithholdFee, isEdit: false },
            ]

            if(data.doubtContent){
              this.doubtContent = JSON.parse(data.doubtContent)
            }else{
              this.doubtContent = []
            }


            if(data.doubtContent){
               let colorList = JSON.parse(data.doubtContent)
               if(colorList.length > 0){
                 if(colorList[colorList.length - 1].doubtOption){
                   this.colorList = colorList[colorList.length - 1].doubtOption
                 }else{
                   this.colorList = []
                 }
               }else{
                  this.colorList = []
               }
            }else{
               this.colorList = []
            }

         }
         else{
            this.$message.error("获取数据失败");
         }
      })
    },


    handleClickTable(row){
      
    },

    handleClosedataList(){
      this.dataList = []
      this.dialogVisiblehandleClosedataList = false
    },

    handleClosedataList1(){
      this.dataList1 = []
      this.dialogVisiblehandleClosedataList1 = false
    },

    handleClosedataList2(){
      this.dataList2 = []
      this.dialogVisiblehandleClosedataList2 = false
    },

    hnadleDetalis(url,data,list){
      return axios.post(`${apiBaseUrl}${url}`, data, {headers: { authorization: sessionStorage.getItem('tokenInfo') },}).then((response) => {

        console.log(response.data)

        if (response.data.code === 200) {
          this.$message({ message: response.data.message, type: 'success' });
          if(list === 1){
            this.dataList = response.data.data.records
          }
          if(list === 2){
            this.dataList1 = response.data.data.records
          }
          if(list === 3){
            this.dataList2 = response.data.data.records
          }
          this.getList();
          return true; 
        } else {
          this.$message({ message: response.data.messages, type: 'error' });
          if(list === 1){
            this.dataList = []
          }
          if(list === 2){
            this.dataList1 = []
          }
          if(list === 3){
            this.dataList2 = []
          }
          return false; 
        }
      }).catch((error) => {
        this.$message({ message: error.message || '请求失败', type: 'error' });
        if(list === 1){
          this.dataList = []
        }
        if(list === 2){
          this.dataList1 = []
        }
        if(list === 3){
          this.dataList2 = []
        }
        return false; 
      });
    },

    handleView(type, typeIngo, row){

      let rowCopy = ''

      if(type === '查看'){

        if(typeIngo === '底薪'){
       
        }

        if(typeIngo === '管理职级'){

        }

        if(typeIngo === '课时费'){
          console.log(row.date)
          let type = row.date === '小学' ? 1 : row.date === '初中' ? 2 : 3
          this.dialogVisiblehandleClosedataList = this.hnadleDetalis('/salary/findTeacherClass',{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, phaseStudying: type}, 1)
        }

        if(typeIngo === '补助'){
          console.log(row.date)
          let url = ''
          if(row.date === '上门路补(课时)' || row.date === '上门路补(半)' || row.date === '上门路补(全)'){
            this.isTyle = true
            this.sourceswayType = 1
            url = '/salary/findTeacherWay'
            //  this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, wayType: row.date === '上门路补(全)' ? 1 : 1 }, 1)
            this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 1)
          }
          if(row.date === '单日五节(天)'){
            this.isTyle = false
            url = '/salary/findTeacherOneFive'
             this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 1)
          }
          if(row.date === '晚10路补(节)'){
            this.isTyle = false
            url = '/salary/findTeacherNightEight'
             this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 1)
          }
          if(row.date === '远程路补(节)'){
            this.isTyle = false
            url = '/salary/findTeacherLongWay'
             this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 1)
          }
          if(row.date === '社保补助'){
            this.isTyle = false
            url = '/salary/findTeacherLongWay'
             this.dialogVisiblehandleClosedataList = this.hnadleDetalis(url,{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 1)
          }
        }


        if(typeIngo === '奖励'){
          console.log(row.date)
          if(row.date === "扩科奖励(科)"){
             this.dialogVisiblehandleClosedataList1 = this.hnadleDetalis('/expand/pageSalary',{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 2)
          }
          if(row.date === "内推奖励(人)"){
             this.dialogVisiblehandleClosedataList2 = this.hnadleDetalis('/salary/findTeacherIntroducer',{ pageNum: 1, pageSize: 10000, id: this.DetailsRow.id, }, 3)
          }
        }


        if(typeIngo === '义务课时'){
          
        }


        if(typeIngo === '扣款'){
          
        }


      }

      if(type === '编辑'){

        
        
        if(typeIngo === '管理绩效'){
           this.managementRankFeesShow = true
        }

        if(typeIngo === '扣款'){
            rowCopy = row.name
            console.log(row)
            row.isEdit = true
        }

        if(typeIngo === '底薪'){
           this.rankShow = true
        }

        if(typeIngo === '补助'){
            rowCopy = row.name
            console.log(row)
            row.isEdit = true
        }

        if(typeIngo === '社保'){
            rowCopy = row.name
            console.log(row)
            row.isEdit = true
        }

      }


      if(type === '保存'){

      


        if(typeIngo === '管理绩效'){
          this.managementRankFeesShow = !this.handleClickUrlUpute('/salary/updatePerformance', { id: this.DetailsRow.id, managePerformance: this.managementRankFees })
          this.getList();
        }

        if(typeIngo === '底薪'){
          this.rankShow = !this.handleClickUrlUpute('/salary/updateBasicSalary', { id: this.DetailsRow.id, basicSalary: this.rank })
          this.getList();
        }

        
        if(typeIngo === '补助'){
          if(row.date === '上门路补(课时)'){
            // row.isEdit = !this.handleClickUrlUpute('/salary/updateWayMoney', { id: this.DetailsRow.id, dutyLateNum: row.name, wayMoney: row.address })
             row.isEdit = !this.handleClickUrlUpute('/salary/updateWayMoney', { id: this.DetailsRow.id,  wayMoney: row.address })
             this.getList();
          }

          if(row.date === '上门路补(半)'){
            row.isEdit = !this.handleClickUrlUpute('/salary/******', { id: this.DetailsRow.id, wayType: 2 ,classLateNum: row.name, classLateWithhold: row.address })
          }

          if(row.date === '单日五节(天)'){
            // row.isEdit = !this.handleClickUrlUpute('/salary/updateOneClassMoney', { id: this.DetailsRow.id, teachingAccidentNum: row.name, teachingAccidentWithhold: row.address })
             row.isEdit = !this.handleClickUrlUpute('/salary/updateOneClassMoney', { id: this.DetailsRow.id,  oneClassMoney: row.address })
             this.getList();
          }

          if(row.date === '晚10路补(节)'){
            // row.isEdit = !this.handleClickUrlUpute('/salary/findTeacherNightEight', { id: this.DetailsRow.id, leaveNum: row.name, leaveWithhold: row.address })
             row.isEdit = !this.handleClickUrlUpute('/salary/updateNightEightMoney', { id: this.DetailsRow.id,  nightEightMoney: row.address })
             this.getList();
          }

          if(row.date === '远程路补(节)'){
            // row.isEdit = !this.handleClickUrlUpute('/salary/updateLongWayMoney', { id: this.DetailsRow.id, matterLeaveNum: row.name, matterLeaveWithhold: row.address })
            row.isEdit = !this.handleClickUrlUpute('/salary/updateLongWayMoney', { id: this.DetailsRow.id,  longWayMoney: row.address })
            this.getList();
          }
          if(row.date === '社保补助'){
            // row.isEdit = !this.handleClickUrlUpute('/salary/updateSecurityWithhold ', { id: this.DetailsRow.id, matterLeaveNum: row.name, matterLeaveWithhold: row.address })
            row.isEdit = !this.handleClickUrlUpute('/salary/updateSecurityWithhold ', { id: this.DetailsRow.id,  socialSecurityFee: row.address })
            this.getList();
          }
        }

        if(typeIngo === '扣款'){

          if(row.date === '上班迟到扣款(次)'){
            row.isEdit = !this.handleClickUrlUpute('/salary/updateDutyLate', { id: this.DetailsRow.id, dutyLateNum: row.name, dutyLateWithhold: row.address })
            this.getList();
          }

          if(row.date === '上课迟到扣款(次)'){
            row.isEdit = !this.handleClickUrlUpute('/salary/updateClassLateNum', { id: this.DetailsRow.id, classLateNum: row.name, classLateWithhold: row.address })
            this.getList();
          }

          if(row.date === '教学事故扣款(次)'){
            row.isEdit = !this.handleClickUrlUpute('/salary/updateTeachingAccident', { id: this.DetailsRow.id, teachingAccidentNum: row.name, teachingAccidentWithhold: row.address })
            this.getList();
          }

          if(row.date === '周末/节假日请假扣款(次)'){
            row.isEdit = !this.handleClickUrlUpute('/salary/updateLeaveWithhold', { id: this.DetailsRow.id, leaveNum: row.name, leaveWithhold: row.address })
            this.getList();
          }

          if(row.date === '事假扣款'){
            row.isEdit = !this.handleClickUrlUpute('/salary/updateMatterLeave', { id: this.DetailsRow.id, matterLeaveNum: row.name, matterLeaveWithhold: row.address })
            this.getList();
          }
          
        }

        console.log(row)

        if(row.date === '社保金额'){
           row.isEdit = !this.handleClickUrlUpute('/salary/updateSecurityWithholdFee', { id: this.DetailsRow.id,  socialSecurityWithholdFee: row.address })
           this.getList();
        }
      
      }

      if(type === '取消'){
         console.log(row)
         row.name = rowCopy
         row.isEdit = false
      }


    },

    handleClickUrlUpute(url,data){
      return axios.post(`${apiBaseUrl}${url}`, data, {headers: { authorization: sessionStorage.getItem('tokenInfo') },}).then((response) => {
        if (response.data.code === 200) {
          this.$message({ message: response.data.message, type: 'success' });
          this.getList();
          return true; 
        } else {
          this.$message({ message: response.data.messages, type: 'error' });
          return false; 
        }
      }).catch((error) => {
        this.$message({ message: error.message || '请求失败', type: 'error' });
        return false; 
      });
    },


    handleClick(){
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      const creatTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`; 

      let len = this.doubtContent.length;
      if (len > 0) {
        this.doubtContent[len - 1].auditContent = this.textareass;
        this.doubtContent[len - 1].PCTime = creatTime;
      } else {
        this.doubtContent.push({ auditContent: this.textareass, PCTime: creatTime });
      }

      let data = {
        id: this.DetailsRow.id,
        doubtContent: JSON.stringify(this.doubtContent),
      }

      axios.post(`${apiBaseUrl}/salary/audit`, data,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        if(response.data.code == 200){
          this.$message({   message: '审核成功',  type: 'success'   });
          this.getList();

        }else{
          this.$message({   message: '审核s失败',  type: 'error'   });
        }
      }).catch(error => { 
        this.$message({   message: error,  type: 'error'   });
      })

    },


  }

};
</script>

<style scoped lang="less">

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/ .el-collapse-item__header {
  font-size: 15px !important;
  font-weight: 900;
}

.box{
    text-align: start;
    padding-left: 10px;
    height: 185px;
    overflow-y: auto;
    border: 1px solid #dcd5d5;
    border-radius: 9px;
    padding-top: 10px;
}


</style>



// WEBPACK FOOTER //
// src/manager/salary/SalaryTypeDetails.vue